<template>
    <div class="podcasts-index">

        <admin-layout v-if="isBackend">

            <app-content-pane class="ml-3">
                <template #title>
                    <div class="px-4 pt-3">
                        <h1>Social Change Podcasts</h1>
                        <p>
                            Spark empathy, open intelligent discussion, and drive students to become
                            changemakers by introducing them to real stories about relevant social
                            issues through our podcast episodes.
                        </p>
<!--                        <nav>-->
<!--                            <ol class="breadcrumb">-->
<!--                                <li class="breadcrumb-item active">Podcasts</li>-->
<!--                            </ol>-->
<!--                        </nav>-->
                    </div>
                </template>

                <hr>

                <section class="px-4 py-3">
                    <div class="podcast-list">
                        <div class="row">
                            <template v-for="(podcast, index) in podcasts">

                                <template v-if="index === 0">
                                    <div class="col-12 border-bottom mb-3" :key="podcast.shot_name">
                                        <!-- TODO: Use max-size instead of colums logic, use columns only for preview & description -->
                                        <div class="row align-items-center justify-content-center">
                                            <div class="col-md-7">
                                                <podcast-card :featured="true"
                                                              :podcast="podcast"
                                                              :show-download="false"
                                                              :open-in-modal="isBackend"
                                                              class="mb-4"/>
                                            </div>
                                            <div class="col-md-5">
                                                <h2 class="text-secondary mb-3">
                                                    Help Students to Build Empathy and Become Changemakers
                                                    With the Design for Change podcast
                                                </h2>
                                                <p>
                                                    If you are interested in building a unique experience for students,
                                                    you can start by choosing from the library of social cause podcasts.
                                                    Students build empathy around the selected topic by listening to
                                                    the podcast, each of which is under 10 minutes. Then, take action
                                                    by facilitating our Empathy Warmup exercises or starting a Change
                                                    Project.
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </template>

                                <template v-else>
                                    <div class="col-md-6 col-xl-4" :key="podcast.id">
                                        <podcast-card :podcast="podcast"
                                                      :open-in-modal="isBackend"
                                                      class="mb-4"/>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </section>

            </app-content-pane>

        </admin-layout>

        <public-layout v-else :headless="headless">

            <template #title>
                Engage your students.
            </template>

            <div class="container">
                <div class="podcast-list mt-4">
                    <div class="row">
                        <template v-for="(podcast, index) in podcasts">

                            <template v-if="index === 0">
                                <div class="col-12 border-bottom mb-3" :key="podcast.short_name">
                                    <div class="row align-items-center">
                                        <div class="col-md-8">
                                            <podcast-card :featured="true"
                                                          :headless="headless"
                                                          :podcast="podcast"
                                                          :show-groups="false"
                                                          class="mb-4"/>
                                        </div>
                                        <div class="col-md-4">
                                            <h2 class="text-secondary mb-3">Get Going With Empathy Warmup Podcasts</h2>
                                            <p>
                                                If you are interested in building a unique experience for students, you can start by choosing from the library of social cause podcasts. Students build empathy around the selected topic by listening to the podcast, each of which is under 10 minutes.
                                                Then, download and use our
                                                <a href="https://f.hubspotusercontent20.net/hubfs/6395720/Design%20for%20Change%20USA%20Toolkit/Design%20for%20Change%20USA%20-%20Empathy%20Warmup%20Toolkit%20-%202021-2022.pdf"
                                                   target="_blank">free Empathy Warmup Toolkit</a>
                                                that outlines activities to engage students in the Design for Change framework.
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </template>


                            <template v-else>
                                <div class="col-md-6 col-xl-4" :key="podcast.id">
                                    <podcast-card :podcast="podcast"
                                                  :headless="headless"
                                                  :show-start="false"
                                                  :show-download="true"
                                                  :show-groups="false"
                                                  class="mb-4"/>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>

        </public-layout>

    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import AppLayout from "@/Layouts/AppLayout";
import PublicLayout from "@/Layouts/PublicLayout";
import PodcastCard from "@/Components/Podcast/PodcastCard";
export default {
    name: "Index",
    components: {PodcastCard, PublicLayout, AppLayout, AppContentPane, AdminLayout},
    props: ['podcasts', 'isBackend', 'headless', 'onloaded'],

    computed: {
    },

    mounted() {
        location.href = 'https://designforchange.us/podcasts';

        if( typeof window.parent[ this.onloaded ] === 'function' ){
            window.parent[ this.onloaded ]();
        }
    }

}
</script>

<style lang="scss" scoped>

</style>
*/9*-*//87--*
